module.exports = __webpack_public_path__ + "img/21-image-1@2x.60dd3a92.png";